<template>
    <div class="app">
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>

<script setup>
    import { setAttributes, useCursor, useHeadSafe } from '#imports';
    import 'virtual:svg-icons-register';

    import { useRef } from '@resn/gozer-vue';

    const { cursor } = useCursor();
    const bodyRef = useRef('body');

    setAttributes(bodyRef, { cursor });

    useHeadSafe({
        htmlAttrs: {
            lang: 'en',
        },
        meta: [{ name: 'theme-color', content: '#000000' }],

        // link: [
        //     { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
        //     { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
        //     { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
        //     { rel: 'manifest', href: '/site.webmanifest', crossorigin: 'use-credentials' },
        //     { rel: 'shortcut icon', href: '/favicon.ico' },
        // ],
    });
</script>

<style lang="scss">
    @use '@/styles/critical.scss';
    @use '@/styles/main.scss';
</style>
